module.exports = __webpack_public_path__ + "img/01-T.3bc7f44e.png";